import { useTranslation } from "react-i18next";
import "../translations/i18n";

export const ArticleData = (props) => {

  const { t } = useTranslation();

  let localDate = new Date().toLocaleDateString("en-GB")
  let createdAt = new Date().getFullYear() +'-'+ ( new Date().getMonth() + 1)  + '-' + new Date().getDay()  
  let title = "", val = props.search ? `<strong>${ props.search }</strong>` : "", articles = 
    props.articles.filter( dat => String(dat.comment) !== "3" ).map(article => {
      title = article.title
      title = props.search ? title.replace(props.search, val) : title
      localDate = new Date(article.createdAt).toLocaleDateString("en-GB")
      createdAt = new Date(article.createdAt).getFullYear() +'-'+ ( new Date(article.createdAt).getMonth() + 1)  + '-' + new Date(article.createdAt).getDay()  
      const image = article.images?.[0]?.image || article.images?.image || "/img/background.png";
      const category = article.category || {};
      return(
        <div className={ props.col ? props.col : "col-xl-4 col-md-6 mt-3"} key={article.id}>
          <article>

              <div className="post-img p-2 rounded rounded-2">
                  <a href={"/articles/" + article.id }>
                  <center>
                  { 
                    props.col ?
                    <img src={ image } alt={ article.title } className="img-fluid"  style={{ top: 0, left: 0, width: '100%', zIndex: -1 }}/>
                    :<img src={ image } alt={ article.title } className="img-fluid" style={{ width : 550 +"px", height : 250 + "px" }} />
                  }</center>
                  </a>
                </div>
              {
                category.parentId == null ? 
                  <p className="post-category m-0 p-0 small" style={{ fontSize : 12  }}><small> <time dateTime={createdAt}>{ localDate } </time> </small> <span style={{ color : 'red'}}><i className={ category.icone }></i> { category.name }</span> </p>
                :
                  <p className="post-category text-truncate"><i className={ category.icone }></i> { category.name }</p>
              }

              <div className="title p-0 m-0" style={{  fontSize : 15 }}>
                  <a href={"/articles/" + article.id} className="font-normal h6 p-0 m-0"><div dangerouslySetInnerHTML={{ __html: title }} /> </a>
              </div>
              <div className="text-end mt-2">
                <a href={"/articles/" + article.id } className="btn_plus">Lire plus</a>
              </div>
          </article>

        </div>
      )
    })

  return ( articles );
};
